import BaseModel from "../base/baseModel";

export default class AreaAbrangenciaFaixaModel extends BaseModel {
    id: number | null = null;
    areaAbrangenciaId: number | null = null;
    estadoId = 0;
    nomeEstado = "";
    cidadeId = 0;
    nomeCidade = "";
}
